import moment from "moment";

export default (nota) => {
  const hora = nota.hora ? nota.hora : moment().startOf("day");
  const h = moment(hora);
  const actual = moment(nota.fecha);
  actual.hour(h.hour());
  actual.minute(h.minute());
  nota.hora = actual;
  nota.fecha = actual;
  return nota;
};



// WEBPACK FOOTER //
// ./src/components/notas/modelo.js